let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("7SU8v")).then(() => parcelRequire('7pfgY'));